import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const remindersApi = createApi({
  reducerPath: 'remindersApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) headers.set('Authorization', `Bearer ${token}`);
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Reminder'],
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getTaskReminder: builder.query({
      query: (taskId) => `/reminders/task/${taskId}`,
      providesTags: (result, error, taskId) => [{ type: 'Reminder', id: taskId }],
    }),
    getUserReminders: builder.query({
      query: ({ page = 1, pageSize = 20 } = {}) => `/reminders?page=${page}&pageSize=${pageSize}`,
      providesTags: ['Reminder'],
    }),
    createOrUpdateReminder: builder.mutation({
      query: (body) => ({ url: '/reminders', method: 'POST', body }),
      invalidatesTags: (result, error, { taskId }) => [{ type: 'Reminder', id: taskId }, 'Reminder'],
    }),
    deleteReminder: builder.mutation({
      query: ({ reminderId }) => ({ url: `/reminders/${reminderId}`, method: 'DELETE' }),
      invalidatesTags: (result, error, { taskId }) => [{ type: 'Reminder', id: taskId }, 'Reminder'],
    }),
    snoozeReminder: builder.mutation({
      query: ({ reminderId, snoozeKey }) => ({
        url: `/reminders/${reminderId}/snooze`,
        method: 'POST',
        body: { snoozeKey },
      }),
      invalidatesTags: ['Reminder'],
    }),
  }),
});

export const {
  useGetTaskReminderQuery,
  useGetUserRemindersQuery,
  useCreateOrUpdateReminderMutation,
  useDeleteReminderMutation,
  useSnoozeReminderMutation,
} = remindersApi;
